// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.


import Rails from "@rails/ujs"
window.Turbolinks = require("turbolinks")
import * as ActiveStorage from "@rails/activestorage"
Rails.start()
Turbolinks.start()
ActiveStorage.start()


import "channels"
window.bootbox = require("bootbox/bootbox")
const locale = localStorage.getItem("locale")
import pt from '../src/bootbox/locale_pt.json'
window.bootbox.addLocale("pt", pt)
window.bootbox.setLocale(locale && locale != "undefined" ? locale : "pt")
var $ = require( "jquery" );
window.$ = window.jQuery = jQuery
window.Rails = Rails
import "popper.js"
import bootstrap from 'bootstrap'
import "../src/popups.js"
window.fancybox = require("fancybox")
fancybox(jQuery)
jQuery.extend(jQuery.fancybox.defaults, {
    modal:false
});
import "jquery-ui"
import 'jquery-autocomplete/jquery.autocomplete.js'
require ('jquery.easing')
import "src/jquery_widgets.js"
import "../src/jquery.cookie"
require ("../src/jquery.jstree")
import "../src/jquery.tmpl.min"
import jqGrid from "../src/jqgrid/jquery.jqGrid.src"
import "../src/jquery.khis.dashboardList.js"
import "../src/jquery.khis.dropdownCombo.js"
import "../src/jquery.khis.hierarchySearch.js"
import "../src/jquery.khis.nosologicGroup.js"
import "../src/jquery.khis.participantSelector.js"
import "../src/jquery.khis.patientSelector.js"
import combobox from  "../src/jquery.combobox.js"
import "../src/jquery.contextMenu.js"
import "../src/jquery.cookie.js"
import "../src/jquery.easydrag.js"
import "../src/jquery.iframe-transport.mine.js"
import "../src/jquery.jstree.js"
import "../src/jquery.khis.widget.js"
import "../src/jquery.metadata.js"
import "../src/jquery.orgchart.js"
import "../src/jquery.scrollTo-1.4.2-min.js"
import "../src/jquery.svg.min.js"
import "../src/jquery.tipsy.js"
import "../src/jquery.tmpl.min.js"
import "../src/jquery.touchSwipe.js"
// import "../src/jquery.fileupload-validate"
// import "../src/jquery.fileupload-video"
// import "../src/jquery.fileupload-ui"
// import "../src/jquery.fileupload-process"
// import "../src/jquery.fileupload-audio"
// import "../src/jquery.fileupload"
import "../src/jquery.fileDownload.js"
// import "../src/jquery.fileupload-image"
import "blueimp-canvas-to-blob"
import "blueimp-file-upload"
import 'regenerator-runtime/runtime'

import "select2"
import 'chosen-js'
require ("moment")
require ("js.cookie")
require ("cookie")
require ("highcharts")
import GlobalFn from "../src/global_fn.js"
import Hades from "../src/hades.js"
import Credential from "../src/khis_namespace/CredentialNS.js"
import globalConstants from "../src/khis_namespace/globalConstants.js"
import "../src/ba-debug.min.js"
window.fc = require("../src/calendar/fullcalendar.js")
import "../src/calendar/fullcalendar.min.js"
import "../src/calendar/gcal.js"
import "../src/jqgrid/grid.locale-pt"
import "../src/jqgrid/grid.locale-pt-br"
import "../src/jqgrid/grid.locale-en"
import "../src/khis_namespace/analysis.js"
import "../src/khis_namespace/appointmentNS.js"
import "../src/khis_namespace/assistiveProductNS.js"
import "../src/khis_namespace/bloodNS.js"
import "../src/khis_namespace/cleaningNS.js"
import "../src/khis_namespace/consult.js"
import "../src/khis_namespace/consultProcessNS.js"
import "../src/khis_namespace/continuousCareNS.js"
import "../src/khis_namespace/dental_medicineNS.js"
import "../src/khis_namespace/dentalMedicineMedicalAct.js"
import "../src/khis_namespace/diagnosisNS.js"
import "../src/khis_namespace/dietsNS.js"
import "../src/khis_namespace/episode.js"
import "../src/khis_namespace/exam.js"
import "../src/khis_namespace/exteriorPrescriptionGroupNS.js"
import "../src/khis_namespace/exteriorPrescriptionNS.js"
import "../src/khis_namespace/external_medication.js.erb"
import "../src/khis_namespace/harvestNS.js"
import "../src/khis_namespace/healthCarePlanNS.js"
import "../src/khis_namespace/hospitalization.js"
import "../src/khis_namespace/inpatientNS.js"
import "../src/khis_namespace/inpatientTemporaryExitNS.js"
import "../src/khis_namespace/inpatientTransferNS.js"
import "../src/khis_namespace/kUtils.js"
import "../src/khis_namespace/localPrescriptionNS.js"
import "../src/khis_namespace/localPrescriptionTaskNS.js"
import "../src/khis_namespace/mcdtNS.js"
import "../src/khis_namespace/mcdtProcessNS.js"
import "../src/khis_namespace/medicalAct.js"
import "../src/khis_namespace/medicationNS.js"
import "../src/khis_namespace/notificationNS.js"
import "../src/khis_namespace/occupational_medicine.js"
import "../src/khis_namespace/operatingRoomNS.js"
import "../src/khis_namespace/patientNameSpace.js"
import "../src/khis_namespace/patientOrder.js"
import "../src/khis_namespace/physiotherapy.js"
import "../src/khis_namespace/physiotherapyPlanNS.js"
import "../src/khis_namespace/physiotherapyPrescriptioNS.js"
import "../src/khis_namespace/physiotherapyRequisitionOrder.js"
import "../src/khis_namespace/processNS.js"
import "../src/khis_namespace/professionalNS.js"
import "../src/khis_namespace/reportedPrescriptionNS.js"
import "../src/khis_namespace/surgeryNS.js"
import "../src/khis_namespace/surgeryProcessNS.js"
import "../src/khis_namespace/taskNS.js"
import "../src/khis_namespace/viewControllerNS.js"
import "../src/khis_namespace/workflow.js"
import "../src/khis_namespace/workflowServices.js"
import "../src/khis_namespace/integrationsNS"
import "../src/models/billingModel.js"
import "../src/models/inpatientModel.js"
import "../src/models/patientModel.js"
import "../src/models/surgicalModel.js"
import "../src/utils.js"
import "../src/webcam.js"
import "../src/webcam.min.js"
import "../src/timeline.js"
import "../src/timeline.old.js"
import "../src/timeline-locales.js"
import "../src/timeline-min.js"
import "../src/ui.multiselect.js"
import "../src/underscore.js.erb"
import "../src/notify.min.js"
import "../src/pdfobject.js"
import "../src/k-datepicker.js"
import "../src/kealthlive.js"
import "../src/khis.fromToList.js"
import "../src/websocket/ws_connection.js"
import "../src/consolelog.min.js"
import "../src/datepicker.js.erb"
import GlobalTranslations from "../src/global_translations.js"
import "../src/grid_helper.js"
import "../src/helper.js"
import "../src/horizontal_timeline.js"
import FileUploadHelper from "../src/fileupload_helper.js.erb"
import "../src/knockout-2.0.0.js"
import "../src/templates.js"
import "../src/select2/khis_js.js"
import "../src/chosen.jquery.js"
import "../src/moment.js"
import "../src/moment.min.js"
import "d3/dist/d3.min.js"
// import "../packs/side-bar/index.js"
require("jquery-ui-dist/jquery-ui.js")
window.bigdecimal = require("bigdecimal");
import chart from 'chart.js';
window.Chart = chart
  
 





















